import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import DateTime from '../../../../../../DateTime';
import { ReminderStatus } from '../../../../../../Account/Profile/Reminders/util/reminders';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import { isEmptyArray } from '../../../../../../../core/util/array';

const Root = styled.div.withConfig({ componentId: 'sc-245nhg-0' })`
  &:before {
    display: block;
    content: '';
    height: 1px;
    width: calc(100% + 20px);
    background-color: ${colors.borderLine};
  }

  cursor: pointer;
  margin-top: 12px;
  color: ${colors.black};
`;

const Copy = styled.div.withConfig({ componentId: 'sc-245nhg-1' })`
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  color: ${colors.black};
  position: relative;
  padding: 12px 0;
`;

const Arrow = styled.div.withConfig({ componentId: 'sc-245nhg-2' })`
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  border: 1px solid ${colors.lanaDelGrey};
  border-bottom: none;
  border-left: none;
  position: absolute;
  right: 0;
  top: 35%;
`;

const Date = styled.span.withConfig({ componentId: 'sc-245nhg-3' })`
  font-family: ${fontFamily.bold};
`;

type Props = {
  reminder?: any;
  onClick?: React.MouseEventHandler;
};

export default class NextReminder extends PureComponent<Props> {
  getReminderDate = () => {
    const { reminder } = this.props;

    return !isEmptyArray(reminder?.reminder_dates) && reminder?.notify
      ? DateTime.format(ReminderStatus.getNextReminderDate(reminder))('MMM D, YYYY')
      : 'none set';
  };

  render = () => (
    <Root onClick={this.props.onClick}>
      <Copy>
        Next reminder: <Date>{this.getReminderDate()}</Date> <Arrow />
      </Copy>
    </Root>
  );
}
